import React, { useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { API_DETAILS, COOKIE_KEYS } from "../../App";
import MembershipPanel from "./MembershipPanel";
import PaymentHistoryPanel from "./PaymentHistoryPanel";

/**
 * Billing: the membership, what has been charged for it, and promo codes.
 *
 * These used to sit at the bottom of Personal Information, with the Billing menu
 * item opening that same screen and scrolling down. That made Billing and
 * Personal Information the same destination, which is not what either name
 * promises — so billing is its own view and the profile is only the profile.
 */

const BillingView = (props) => {
  const uId = Cookies.get(COOKIE_KEYS.userId);

  const [promoCode, setPromoCode] = useState("");
  const [promoLoading, setPromoLoading] = useState(false);

  const applyPromoCode = async () => {
    const code = promoCode.trim();
    if (!code || promoLoading) return;

    const url =
      API_DETAILS.baseUrl +
      API_DETAILS.PORT +
      API_DETAILS.baseExtension +
      `/apply-promo?userId=${encodeURIComponent(uId)}&code=${encodeURIComponent(code)}`;

    setPromoLoading(true);
    try {
      await axios.post(url, null, {
        headers: { "Content-Type": "application/json" },
      });
      toast.success("Promo applied! Subscription activated.");
      setPromoCode("");
      // The membership panel reads its state on mount, so it has to be told to
      // look again rather than keep showing the plan the patient had a moment ago.
      setTimeout(() => window.location.reload(), 1200);
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        (typeof err?.response?.data === "string" ? err.response.data : null) ||
        err?.message ||
        "Failed to apply promo code";
      toast.error(message);
    } finally {
      setPromoLoading(false);
    }
  };

  const card = {
    padding: "24px",
    borderRadius: "10px",
    backgroundColor: "var(--card)",
    border: "1px solid var(--border)",
  };

  return (
    <div style={{ maxWidth: "896px", margin: "0 auto", padding: "32px", width: "100%" }}>
      <ToastContainer />

      <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "32px" }}>
        <button
          onClick={() => props.openProfileMenu?.()}
          style={{
            padding: "8px",
            borderRadius: "8px",
            border: "1px solid var(--border)",
            backgroundColor: "var(--card)",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m12 19-7-7 7-7" /><path d="M19 12H5" />
          </svg>
        </button>
        <div>
          <h2 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 600 }}>Billing</h2>
          <p style={{ margin: "4px 0 0", opacity: 0.7, fontSize: "0.875rem" }}>
            Your membership, payments and refunds
          </p>
        </div>
      </div>

      <MembershipPanel />

      <PaymentHistoryPanel />

      <div style={card}>
        <h3 style={{ margin: 0, fontFamily: "Nunito, sans-serif", fontSize: "20px", fontWeight: 600 }}>
          Promo Code
        </h3>
        <p style={{ margin: "8px 0 16px", fontSize: "14px", color: "var(--youro-charcoal)", opacity: 0.75 }}>
          Have a code? Enter it here to activate a membership without payment.
        </p>
        <div style={{ display: "flex", gap: "10px", width: "100%", alignItems: "center" }}>
          <input
            className="input-field input-border"
            type="text"
            placeholder="Enter promo code"
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
            disabled={promoLoading}
          />
          <button
            className="btn-filled"
            type="button"
            onClick={applyPromoCode}
            disabled={promoLoading || !promoCode.trim()}
            style={{ whiteSpace: "nowrap" }}
          >
            {promoLoading ? "Applying..." : "Apply"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingView;
